export const costs = [
  'Sleepless nights translating complex concepts',
  'Improvised classes from disorganized materials',
  "Disconnected students who don't see relevance",
  'Weekends building lesson plans and assessments from scratch',
  'No clear answers when students ask technical questions',
];
